import { COPY_POLICIES, TITLE_COPY_LIMITS } from "../copy-policy";
export const STATEMENT_TITLE_MAX_LENGTH = COPY_POLICIES.title.maxLength;
export const statementSchema = {
    componentId: "Statement",
    scalarSlots: [
        { key: "eyebrow", label: "Eyebrow", type: "text" },
        {
            key: "title",
            ...TITLE_COPY_LIMITS,
            label: "Title",
            type: "textarea",
        },
    ],
    mediaSlots: [],
};
//# sourceMappingURL=statement.js.map